

export enum ObraState {
    TO_START = 'Por iniciar',
    ONGOING = 'Em andamento',
    CANCELLED = 'Cancelada',
    DELIVERED = 'Entregue',
}

export enum TipoOperacao {
    PROJETO = 'Projeto',
    CNC = 'CNC',
    CONVENCIONAIS = 'Convencionais',
    SERROTE = 'Serrote',
    ACABAMENTO = 'Acabamento',
    TRATAMENTO = 'Tratamento',
    CONTROLO_QUALIDADE = 'Controlo e Qualidade',
    EXPEDICAO = 'Expedição',
    SUBCONTRATACAO = 'Subcontratação'
}

export enum EstadoOperacoes {
    POR_INICIAR = 'Por iniciar',
    EM_ANDAMENTO = 'Em andamento',
    EM_PAUSA = 'Em pausa',
    CONCLUIDO = 'Concluído',
    INEXISTENTE= 'Inexistente'
} 

export type IClient = {
    id: number,
    name: string,
    address: string,
    phone: string,
    email: string,
    paymentTime: number,
    score: number,
    distancia: number
}

export type IOrcamento = {
    id: number,
     acceptedPercentage: number,
    name: string,
    billCode: string,
    vaueWithoutIVA: number,
    date: string,
    accepted: boolean,
    
}

export type IMachine = {
    id: number,
    brand: string,
    model: string,
    ref: string,
    axis: number,
    production: number
}

export type IExpedicaoOperacao = {
    data: string,
    observacoes: string,
    quantidade: number,
    guia: string,
    operacao: IOperacao,
    fotos: { path : string}
}


export type IControloQualidade = {
    id?: number, 
    controlada: boolean,
    efetuadoPor: any,
    pecaEntrega: number,
    conforme: boolean,
    observacoes: string,
    created_at: string
}

export type IPecaParaEntrega = {
    id: number,
    peca: IPeca | number,
    entrega: IEntrega | number,
    expedicoesOperacao: IExpedicaoOperacao[],
    quantidade: number,
    controloQualidade: IControloQualidade,
    estadoProjeto: EstadoOperacoes,
    estadoCnc: EstadoOperacoes,
    estadoSerrote: EstadoOperacoes,
    estadoAcabamentos: EstadoOperacoes,
    estadoConvencionais: EstadoOperacoes,
    estadoTratamentos: EstadoOperacoes,
    estadoControloQualidade: EstadoOperacoes,
    estadoExpedicao: EstadoOperacoes,
    medidasConvencionais: {
        comprimento: number,
        largura: number,
        altura: number
    },
    naoConformidadeCliente: {
        id: number
    }
}

export type IEntrega = {
    id: number,
    percentage: number,
    duration: number,
    durationInDays: string,
    productionReadyDate: Date,
    realDeliveryDate: Date,
    startingDate: string,
    publicDeliveryDate: Date,
    pecasParaEntrega?: IPecaParaEntrega[];
    clientNotified: boolean;
}

export type IOperacao = {
    id: number,
    observacoes: string,
    isExternal: boolean,
    dataExpedicao: string,
    medida: string,
    tipo: TipoOperacao

}

export type IMaterial = {
    reference: string,
    densidade: number,
    averagePrice: number
}

export type IPeca = {
    id: number,
    reference: string,
    amount: number,
    material: IMaterial,
    unitPrice: number,
    margem?: number,
    tempoPeca?:number,
    operacoes: IOperacao[],
    desenhosTecnicos: File[]
}

export type IBill = {
    id: number,
    code: string;
    date: string;

}

export type IObra = {

    id: number,
    client: IClient,
    number: string,
    questionnaireSent: boolean;
    value: number,
    orderNote: string,
    partAmount: number,
    overallDuration: number,
    overallDurationInDays: string,
    state: ObraState,
    orcamentos: IOrcamento[],
    machines: IMachine[],
    entregas: IEntrega[],
    bills: IBill[],
    pecas: IPeca[]

}